"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HdWallet = void 0;
const baseHd_1 = require("./baseHd");
const bitcoin_1 = require("./bitcoin");
const ethereum_1 = require("./ethereum");
const thenewboston_1 = require("./thenewboston");
exports.HdWallet = {
    /**
     * Default HdWallet for Custom Coin derivations
     */
    default: (mnemonicOrSeed, coinDetails) => new baseHd_1.BaseHdWallet(mnemonicOrSeed, coinDetails),
    bitcoin: (mnemonicOrSeed) => new bitcoin_1.BtcHdWallet(mnemonicOrSeed),
    ethereum: (mnemonicOrSeed) => new ethereum_1.EthHdWallet(mnemonicOrSeed),
    thenewboston: (mnemonicOrSeed, nodeUrl) => {
        if (!nodeUrl)
            return new thenewboston_1.TnbHdWallet(mnemonicOrSeed, nodeUrl);
        return new thenewboston_1.TnbHdWallet(mnemonicOrSeed, nodeUrl);
    }
};
